import Instagram from '../../src/legacy/Instagram.tsx';
export default Instagram;
